import React from "react"
import { css } from "styled-components"
import { Spacer } from "../../design-system/atoms/layout-primitives/spacer"
import VariantContainer from "../../design-system/atoms/variant-container"
import AccentTitleDivider from "../shared/accent-title-divider/accent-title-divider"
import SdkProjectsCarousel from "./sdk-projects.carousel"

const Carousel = () => {
  return (
    <VariantContainer
      variants={[
        css`
          display: flex;
          flex-direction: column;
        `,
      ]}
    >
      <AccentTitleDivider>Built with Mappedin SDKs</AccentTitleDivider>
      <Spacer height={{ sm: "32px", md: "48px", lg: "96px" }} />
      <SdkProjectsCarousel />
      <Spacer height={{ sm: "32px", md: "48px" }} />
    </VariantContainer>
  )
}
export default Carousel
